export const MAX_SINGLE_DOOR_WIDTH_MM = 600;

export const requiresDoubleDoor = (sectionWidthCm, fallbackWidthCm = 0) => {
  // La largeur rendue dans le schéma fait foi : un brouillon ancien ne peut jamais
  // conserver un vantail simple si la travée affichée dépasse 600 mm.
  const widthCm = Math.max(Number(sectionWidthCm) || 0, Number(fallbackWidthCm) || 0);
  return widthCm * 10 > MAX_SINGLE_DOOR_WIDTH_MM;
};

export const resolveDoorStandard = (section, fallbackWidthCm = 0) => (
  requiresDoubleDoor(section?.width_cm, fallbackWidthCm)
    ? "double"
    : (section?.door_standard || "single_right")
);